"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBase64 = void 0;
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var styled_components_1 = __importDefault(require("styled-components"));
var Modal_1 = __importDefault(require("../../Modal"));
var transifex_1 = require("../../../transifex");
var toBase64 = function (file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () { return resolve(reader.result); };
        reader.onerror = function (error) { return reject(error); };
    });
};
exports.toBase64 = toBase64;
var UploadButton = function () { return (react_1.default.createElement("div", null,
    react_1.default.createElement(icons_1.PlusOutlined, null),
    react_1.default.createElement("div", { style: { marginTop: 8 } }, transifex_1.TX_UPLOAD))); };
var Preview = styled_components_1.default("img")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));
// default avatar height is 104px
var UploadWrapper = styled_components_1.default("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n\n  min-height: ", " !important;\n  min-width: ", " !important;\n\n  & .ant-upload-list-picture-card {\n    .ant-upload-list-item {\n      padding: 0;\n      height: ", ";\n      width: ", ";\n    }\n  }\n\n  .ant-upload-list-picture-card-container {\n    margin: 0px;\n  }\n\n  .ant-upload.ant-upload-select-picture-card {\n    height: ", ";\n    width: ", ";\n    margin-right: 0px;\n    margin-bottom: 0px;\n  }\n"], ["\n  display: inline-block;\n\n  min-height: ",
    " !important;\n  min-width: ",
    " !important;\n\n  & .ant-upload-list-picture-card {\n    .ant-upload-list-item {\n      padding: 0;\n      height: ", ";\n      width: ", ";\n    }\n  }\n\n  .ant-upload-list-picture-card-container {\n    margin: 0px;\n  }\n\n  .ant-upload.ant-upload-select-picture-card {\n    height: ", ";\n    width: ", ";\n    margin-right: 0px;\n    margin-bottom: 0px;\n  }\n"])), function (_a) {
    var _b, _c;
    var dimensions = _a.dimensions;
    return (_c = (_b = dimensions === null || dimensions === void 0 ? void 0 : dimensions.avatar) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : "104px";
}, function (_a) {
    var _b, _c;
    var dimensions = _a.dimensions;
    return (_c = (_b = dimensions === null || dimensions === void 0 ? void 0 : dimensions.avatar) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : "104px";
}, function (_a) {
    var _b, _c;
    var dimensions = _a.dimensions;
    return (_c = (_b = dimensions === null || dimensions === void 0 ? void 0 : dimensions.avatar) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : "104px";
}, function (_a) {
    var _b, _c;
    var dimensions = _a.dimensions;
    return (_c = (_b = dimensions === null || dimensions === void 0 ? void 0 : dimensions.avatar) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : "104px";
}, function (_a) {
    var _b, _c;
    var dimensions = _a.dimensions;
    return (_c = (_b = dimensions === null || dimensions === void 0 ? void 0 : dimensions.avatar) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : "104px";
}, function (_a) {
    var _b, _c;
    var dimensions = _a.dimensions;
    return (_c = (_b = dimensions === null || dimensions === void 0 ? void 0 : dimensions.avatar) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : "104px";
});
var SingleImageWithAvatar = function (_a) {
    var upload = _a.upload, init = _a.init, dimensions = _a.dimensions, on = _a.on;
    var _b = react_1.useState((init === null || init === void 0 ? void 0 : init.fileSrc) || undefined), fileSrc = _b[0], setFileSrc = _b[1];
    var _c = react_1.useState(false), showPreview = _c[0], setShowPreview = _c[1];
    var beforeUpload = function (file, fileList) { return __awaiter(void 0, void 0, void 0, function () {
        var src;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, exports.toBase64(file)];
                case 1:
                    src = (_c.sent());
                    setFileSrc(src);
                    return [4 /*yield*/, ((_a = on === null || on === void 0 ? void 0 : on.base64loaded) === null || _a === void 0 ? void 0 : _a.call(on, src))];
                case 2:
                    _c.sent();
                    if (upload === null || upload === void 0 ? void 0 : upload.beforeUpload) {
                        return [2 /*return*/, (_b = upload === null || upload === void 0 ? void 0 : upload.beforeUpload) === null || _b === void 0 ? void 0 : _b.call(upload, file, fileList)];
                    }
                    return [2 /*return*/, false];
            }
        });
    }); };
    react_1.useEffect(function () {
        setFileSrc((init === null || init === void 0 ? void 0 : init.fileSrc) || "");
    }, [init === null || init === void 0 ? void 0 : init.fileSrc]);
    var fileSource = react_1.useMemo(function () {
        if (fileSrc) {
            return [
                {
                    uid: "1",
                    name: "image.png",
                    url: fileSrc,
                },
            ];
        }
        return undefined;
    }, [fileSrc]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(UploadWrapper, { dimensions: dimensions },
            react_1.default.createElement(antd_1.Upload, __assign({}, upload, { beforeUpload: beforeUpload, listType: "picture-card", showUploadList: true, fileList: fileSource, maxCount: 1, onPreview: function () { return setShowPreview(true); }, onRemove: function () {
                    var _a;
                    setFileSrc(undefined);
                    (_a = on === null || on === void 0 ? void 0 : on.remove) === null || _a === void 0 ? void 0 : _a.call(on);
                }, accept: ".png,.jpg,.jpeg" }), !fileSrc && react_1.default.createElement(UploadButton, null))),
        react_1.default.createElement(Modal_1.default, { visible: showPreview, title: transifex_1.TX_PREVIEW, footer: null, onClose: function () { return setShowPreview(false); } },
            react_1.default.createElement(Preview, { alt: "preview", src: fileSrc }))));
};
exports.default = SingleImageWithAvatar;
var templateObject_1, templateObject_2;
